var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.statData)?_c('div',{staticClass:"article-stat"},[(_vm.articleId > 0)?_c('div',[_vm._v(" "+_vm._s(_vm.statData.article_got_it)+"/"+_vm._s(_vm.statData.article_cnt)+" ")]):_vm._e(),_c('div',[_vm._v(_vm._s(_vm.statData.got_it)+"/"+_vm._s(_vm.statData.cnt))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }